var watchlist = {
	createWatchlistAction: "Volglijst Toevoegen",
	editWatchlistAction: "Volglijst Bewerken",
	deleteWatchlistAction: "Volglijst Verwijderen",
	addPosition: "Positie Toevoegen",
	deletePosition: "Positie Verwijderen",
	noWatchlistTitle: "Info",
	noWatchlistMessage: "Er is nog geen volglijst gemaakt. Klik op de knop Volglijst toevoegen en vul het formulier in om een volglijst te maken.",
	showActions: "Toon acties"
};
var nl = {
	watchlist: watchlist
};

export { nl as default, watchlist };
